import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import Home from "./home";
import { GoogleOAuthProvider } from "@react-oauth/google";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import Profile from "./Profile";
import About from "./About";
import Sign from "./sign";
import Search from "./Search";
import Explore from "./explore";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="561701800707-oiljspvu920o0pfkavpfiedsu7sbrfgj.apps.googleusercontent.com">
    <BrowserRouter>
      <Routes>
        <Route path="/chatgpt" element={<App />} />
        <Route path="/search" element={<Search />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/" element={<Sign />} />
        <Route path="/:Profile" element={<Profile />} />
        <Route path="/About" element={<About />} />
        <Route path="/Explore" element={<Explore />} />
      </Routes>
    </BrowserRouter>
  </GoogleOAuthProvider>
);

reportWebVitals();
